export interface CoverageColumn {
  key: string;
  label: string;
  summable?: boolean;
}

export const COVERAGE_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  EC2: ['Ondemand Cost'],
  RDS: ['Ondemand Cost'],
};

export const SUMMARY_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  EC2: ['Hourly Charges', 'Upfront Price', 'Usage Price'],
  RDS: ['Hourly Price', 'Upfront Price', 'Quantity'],
  Redshift: ['Hourly Price', 'Upfront Price', 'Quantity'],
  ElastiCache: ['Hourly Price', 'Upfront Price', 'Quantity'],
  OpenSearch: ['Hourly Price', 'Upfront Price', 'Quantity']
};

